import FieldsCollection from "../../../../../../../../../core/fields3/collection/base/fields-collection"
import {FieldType} from "../../../../../../../../../core/fields3/field-type"
import {EntityType} from "../../../../../../../../../core/gd/const/item"
import FieldString from "../../../../../../../../../core/fields3/generic/string/string"
import FieldDropdown from "../../../../../../../../../core/fields3/generic/dropdown/dropdown"
import ViewTemplate from "../../../../../../../../../core/manager/view-templates/view-template"
import {ProjectViewAccess} from "../../../../../../../../../core/model2/project-view/@const";

export default class AddViewPreviewFields extends FieldsCollection {

    constructor(templates: ViewTemplate[]) {

        const templatesOptions: any = []

        _.map(templates, template => {
            templatesOptions.push({label: template.name, value: template.id})
        })

        const accessOptions: any = [
            {value: ProjectViewAccess.PRIVATE,  label: 'Private',   icon: 'i5-lock'},
            {value: ProjectViewAccess.PUBLIC,   label: 'Public',    icon: 'i5-people'},
        ]

        const fieldsConfig = [
            {
                fieldId         : 'name',
                type            : FieldType.STRING,
                isRequired      : true,
                description     : 'Enter a name for the view.',
            },
            {
                fieldId         : 'templateId',
                type            : FieldType.DROPDOWN,
                options         : templatesOptions,
                showMenuMore    : false,
                noValueOption   : false,
                description     : 'Select a template to apply your preferred settings for this view.'
            },
            {
                fieldId         : 'access',
                type            : FieldType.DROPDOWN,
                options         : accessOptions,
                showMenuMore    : false,
                noValueOption   : false,
                description     : 'Choose who can view this.'
            },
        ]

        super(fieldsConfig, EntityType.DYNAMIC_MODEL)
    }

    get name()          : FieldString {return this.get('name') as FieldString}
    get templateId()    : FieldDropdown {return this.get('templateId') as FieldDropdown}
    get access()        : FieldDropdown {return this.get('access') as FieldDropdown}
}
